import classNames from 'classnames';
import useGetSelectedYearTaxes from 'hooks/Taxes/useGetSelectedYearTaxes';
import _get from 'lodash/get';
import _sum from 'lodash/sum';
import type { FC } from 'react';
import type { ITax } from 'types/taxes.types';

const TaxesCount: FC<{ isActive?: boolean }> = ({ isActive }) => {
  const { data: taxesData } = useGetSelectedYearTaxes();
  const totalActionsRequired = _sum(
    Object.values(taxesData?.meta?.actionsRequired ?? {}),
  );
  const hasAnyPassedDueDate = (
    Object.values(_get(taxesData, 'meta.dueItems') || {}) as ITax[][]
  )
    ?.flat()
    ?.some((item) => _get(item, 'hasDueDatePassed'));

  if (isActive || !totalActionsRequired) return null;

  return (
    <div
      className={classNames(
        'animate-countBadge !opacity-100 ml-2 px-2 font-weight-500 text-xs z-50',
        'rounded-full',
        'flex items-center justify-center',
        hasAnyPassedDueDate
          ? 'bg-[#FEE2E2] text-red-700'
          : 'bg-yellow-200 text-yellow-700',
      )}
    >
      {totalActionsRequired}
    </div>
  );
};

export default TaxesCount;
